import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import '../styles/Contact.css';

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await axios.post('/api/contact', formData);
      setStatus('success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>
      </section>

      <section className="contact-content section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info">
              <h2>{t('contact.info.title')}</h2>
              
              <div className="contact-method">
                <div className="contact-icon">✉️</div>
                <div>
                  <h3>{t('contact.info.email.label')}</h3>
                  <p><a href="mailto:tarot@saramwhite.com">{t('contact.info.email.value')}</a></p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">📍</div>
                <div>
                  <h3>{t('contact.info.location.label')}</h3>
                  <p>{t('contact.info.location.value')}</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">🕐</div>
                <div>
                  <h3>{t('contact.info.hours.label')}</h3>
                  <p>{t('contact.info.hours.value')}</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">📷</div>
                <div>
                  <h3>{t('contact.info.social.label')}</h3>
                  <p>
                    <a href="https://instagram.com/tarot_sara_white" target="_blank" rel="noopener noreferrer">
                      {t('contact.info.social.instagram')}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <form onSubmit={handleSubmit} className="contact-form">
                <h2>{t('contact.form.title')}</h2>
                
                <div className="form-group">
                  <label>{t('contact.form.name')}</label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name}
                    onChange={handleChange} 
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>{t('contact.form.email')}</label>
                  <input 
                    type="email" 
                    name="email" 
                    value={formData.email}
                    onChange={handleChange} 
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>{t('contact.form.phone')}</label>
                  <input 
                    type="tel" 
                    name="phone" 
                    value={formData.phone}
                    onChange={handleChange} 
                  />
                </div>

                <div className="form-group">
                  <label>{t('contact.form.subject')}</label>
                  <input 
                    type="text" 
                    name="subject" 
                    value={formData.subject}
                    onChange={handleChange} 
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>{t('contact.form.message')}</label>
                  <textarea 
                    name="message" 
                    value={formData.message}
                    onChange={handleChange} 
                    rows="5"
                    required 
                  />
                </div>

                <button type="submit" className="btn btn-primary" disabled={status === 'sending'}>
                  {status === 'sending' ? t('contact.form.sending') : t('contact.form.send')}
                </button>

                {status === 'success' && (
                  <p className="form-message success">{t('contact.form.success')}</p>
                )}
                {status === 'error' && (
                  <p className="form-message error">{t('contact.form.error')}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
